import { Navigate, useParams } from 'react-router-dom';
import { savePendingSessionId } from './pendingSession';

/**
 * セッションごとの参加 QR の受け口 `/m/:urlToken/join/:sessionId` (2026-09-04)。
 *
 * 旧2 `App.tsx` の `OldUrlRedirect` (旧 URL `/m/{token}/{sessionId}` → sessionStorage 保存 →
 * `/m/{token}` へ) を踏襲。v2 では参加 QR を管理画面から発行できるようにしたため、
 * 「保険の互換ルート」ではなく**正規の入口**として置く。
 *
 * 動作:
 *   1. 参加予定のセッションを sessionStorage に保存 (未参加者が ユーザー設定 を通る間の持ち回り)
 *   2. 既存の deep route `/m/:urlToken/:sessionId/map` へ置換遷移
 *      - 参加済みの人 … `useApplyUrlSessionId` が現在のセッションとして適用する
 *      - 未参加の人 … `RequireOnboarding` が入口へ戻し、ユーザー設定でこのセッションが参加セッションの初期選択になる
 *
 * QR が指す URL を 1 本にしておくことで、印刷物を配る相手が参加済みかどうかを気にせず配れる。
 */
export function SessionJoinPage() {
  const { urlToken, sessionId } = useParams<{ urlToken: string; sessionId: string }>();

  if (!urlToken || !sessionId) {
    return <Navigate to="/" replace />;
  }

  // render 中の副作用だが、旧2 同様「この画面は保存して即リダイレクトするだけ」なので
  // effect を待たずに保存する (effect にすると Navigate が先に走り保存前に画面が消えうる)。
  savePendingSessionId(urlToken, sessionId);

  return <Navigate to={`/m/${urlToken}/${sessionId}/map`} replace />;
}
